import { excludeGraphQLFetch } from "apollo-link-sentry";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const ENVIRONMENT =
  process.env.SENTRY_ENVIRONMENT || process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
const SENTRY_RELEASE =
  process.env.SENTRY_RELEASE || process.env.NEXT_PUBLIC_SENTRY_RELEASE;

// Runtime-agnostic options only - client-only integrations (tracing, replay)
// live in instrumentation-client.ts, since @sentry/nextjs ships separate
// client/server/edge builds and only the client one exports them. Untyped
// here on purpose: client/server/edge each have their own distinct Options
// type (BrowserOptions/NodeOptions/EdgeOptions), none of which is re-exported
// standalone from @sentry/nextjs - each `Sentry.init({ ...baseSentryConfig })`
// call site is what actually gets checked against the right one.
export const baseSentryConfig = {
  dsn: SENTRY_DSN,
  tracesSampleRate: 0.01,
  sampleRate: 1,
  autoSessionTracking: true,
  release: SENTRY_RELEASE,
  tracePropagationTargets: [/bff\.\w+\.punct\.co\.il/],
  beforeBreadcrumb: excludeGraphQLFetch,
  environment: ENVIRONMENT,
};
